module.exports = __webpack_public_path__ + "img/logo.e513175c.png";